import React from "react";

import * as colors from "src/styles/constants/colors";

type Props = {
  fill?: string;
  color?: string;
};

const FilledCross = ({
  fill = colors.brightLight,
  color = colors.primary,
  ...restProps
}: Props) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8Z"
      fill={fill}
    />
    <mask
      id="mask0_426_1064"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="17"
      height="16"
    >
      <rect x="0.5" width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_426_1064)">
      <path
        d="M6.09996 11.3336L5.16663 10.4003L7.56663 8.00026L5.16663 5.61693L6.09996 4.68359L8.49996 7.08359L10.8833 4.68359L11.8166 5.61693L9.41663 8.00026L11.8166 10.4003L10.8833 11.3336L8.49996 8.93359L6.09996 11.3336Z"
        fill={color}
      />
    </g>
  </svg>
);

export default FilledCross;
